import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestResultStorage = ( createDecorator('ITestResultStorage'));
export { ITestResultStorage };
